
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12428',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12428",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.475",
  "data-fetching-client": "static-1.9716",
  "foundations-components": "static-1.8031",
  "foundations-components-legacy": "static-1.1056",
  "foundations-theming": "static-1.4476",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8069",
  "hub-http-shared-msw-handlers": "static-1.10088",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11525",
  "I18n": "static-7.1633",
  "jasmine-runner": "static-1.6515",
  "marketplace-storefront-base": "static-1.12489",
  "quartz": "static-1.7095",
  "react-dlb": "static-1.80",
  "react-rhumb": "static-1.16731",
  "reactive-variable-buffer-atom": "static-1.2910",
  "reporting-testing-lib": "static-1.9713",
  "settings-ui-lib": "static-1.12571",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7234",
  "ui-addon-i18n": "static-1.11203",
  "ui-addon-react-router-dom": "static-1.9593",
  "unified-auth": "static-1.555",
  "unified-auth-core-lib": "static-1.837",
  "usage-tracker": "static-1.7402",
  "usage-tracker-core": "static-1.7252",
  "customer-data-property-utils": "static-1.8144",
  "hub-http": "static-1.6274",
  "integrations-lib": "static-1.16330",
  "marketplace-ui-common": "static-1.19960",
  "property-management-iframe": "static-1.13331",
  "quartz-config": "static-1.873",
  "quartz-core": "static-1.6314",
  "quartz-routing": "static-1.525",
  "quick-fetch": "static-1.3958",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4704",
  "ts-schema": "static-1.4120",
  "ui-universal-auth": "static-1.9041",
  "UIComponents": "static-3.8471",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3440",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3372",
  "quartz-webpack": "static-1.3319",
  "bend-plugin-quartz-routing": "static-1.173",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4300",
  "floating-ui": "static-1.57",
  "foundations-assets": "static-1.4921",
  "foundations-theming-specialty": "static-1.2192",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9475",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.31",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5384",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.488",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2075",
  "ui-fonts": "static-1.787",
  "ui-images": "static-2.1165",
  "bend-plugin-foundations-theming": "static-1.2959",
  "foundations-theming-base": "static-1.3461",
  "stylex": "static-1.34",
  "HeadJS": "static-2.765",
  "hs-test-utils-bend-plugin": "static-1.3180",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4377",
  "ai-components-ui-library": "static-1.9097",
  "ai-rendering-library": "static-1.10349",
  "chirp-fetch": "static-1.1939",
  "connections-embed-lib": "static-1.1089",
  "copilot-toolkit": "static-1.11272",
  "feedback-loader": "static-1.29391",
  "laboratory-lib": "static-3.7208",
  "marketplace-embed": "static-1.22236",
  "marketplace-ui-details": "static-1.9855",
  "marketplace-ui-reviews": "static-1.19915",
  "marketplace-ui-tracking": "static-1.14130",
  "sanitize-text": "static-1.8194",
  "ui-addon-video-player": "static-1.8756",
  "usage-tracker-multi": "static-1.5816",
  "usage-tracker-session-replay": "static-1.5088",
  "wootric-nps": "static-1.7022",
  "quartz-head": "static-1.760",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4703",
  "immer": "static-1.33",
  "immerable": "static-1.4205",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2525",
  "reporting-data": "static-1.67780",
  "cssUtils": "static-1.804",
  "flux-actions": "static-1.341",
  "HubStyle": "static-2.11832",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10261",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10417",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7392",
  "icons": "static-2.650",
  "marketplace-ui-apps-core": "static-1.18492",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4565",
  "foundations-components-test-utils": "static-1.5514",
  "quartz-i18n": "static-1.770",
  "react-input-autosize": "static-2.17",
  "ads-unified-auth-lib": "static-1.39",
  "google-sheets-integration-lib": "static-1.387",
  "microsoft-drive-integration-lib": "static-1.522",
  "slack-ui-library": "static-1.10444",
  "fsm": "static-1.3782",
  "customer-data-objects": "static-1.7729",
  "property-translator": "static-1.5450",
  "hs-locale-management": "static-1.121",
  "frontend-preferences-client": "static-1.7978",
  "hs-promise-utils": "static-1.5643",
  "hubspot-apollo-client": "static-1.4929",
  "integrations-error-boundary-lib": "static-1.13745",
  "integrations-tracking-lib": "static-1.5657",
  "native-integrations-shared-strings": "static-1.7834",
  "reselect": "static-2.16",
  "sanitize": "static-1.4528",
  "superstore": "static-1.4812",
  "ui-shepherd-react": "static-3.10264",
  "ai-settings-ui-library": "static-1.7966",
  "hub-http-janus": "static-1.839",
  "hubspotter-http": "static-1.4691",
  "immutable-less": "static-1.4704",
  "marketplace-ui-client-types": "static-1.17367",
  "nav-meta": "static-1.29803",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10300",
  "ui-addon-upgrades": "static-9.18069",
  "inbound-db-properties-service-client": "static-1.3886",
  "property-management-common": "static-1.5619",
  "ui-addon-iframeable": "static-1.9113",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.770",
  "quartz-test": "static-1.770",
  "quartz-tracking": "static-1.474",
  "trellis-components": "static-1.2094",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.114",
  "bender-build-tools": "static-1.3254",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21525",
  "ContentUtils": "static-1.68516",
  "customer-data-objects-ui-components": "static-1.13084",
  "sassPrefix": "static-1.157",
  "breeze-engine-core": "static-1.115",
  "breeze-onboarding-components": "static-1.138",
  "avatar-components": "static-1.2550",
  "customer-data-filters-ui": "static-1.39978",
  "customer-data-reference-ui-components": "static-1.13221",
  "embedded-academy-lib": "static-1.14512",
  "ExportDialog": "static-6.10437",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41443",
  "reporting-snowflake": "static-1.56398",
  "reporting-ui-components": "static-2.65051",
  "reporting-visualizations": "static-1.59856",
  "ui-addon-teams": "static-1.21625",
  "magpie-lib": "static-1.5585",
  "navigation-components": "static-1.18166",
  "breeze-engine-lib": "static-1.837",
  "magpie-types": "static-1.5045",
  "simple-logging-lib": "static-1.3103",
  "ai-studio-lib": "static-1.11763",
  "app-governance-lib": "static-1.1718",
  "developer-experience-shared-components": "static-1.10564",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8054",
  "ui-product-approvals": "static-1.28303",
  "ui-tool-access": "static-1.10201",
  "usage-based-billing-components-lib": "static-1.9178",
  "usage-tracker-anonymous": "static-1.5819",
  "usage-tracker-public": "static-1.7213",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3626",
  "persist-promise": "static-1.3751",
  "reference-resolvers": "static-1.8223",
  "ui-extensibility-client-types": "static-1.3978",
  "hubspot-apollo-cache": "static-1.388",
  "universal-page-editor-lib": "static-1.3070",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2922",
  "merchandise-lib": "static-1.265",
  "atom": "static-1.5126",
  "purchase-motions-components": "static-1.6007",
  "salesImages": "static-1.526",
  "batch-promise": "static-1.1594",
  "crm-component-utils": "static-1.39214",
  "crm-properties-common-lib": "static-1.5940",
  "customer-data-properties": "static-1.51751",
  "framework-data-schema-resolvers": "static-1.6940",
  "property-value-citations": "static-1.2365",
  "reference-resolvers-lite": "static-1.8150",
  "ui-business-units-lib": "static-1.9109",
  "navigation-messaging": "static-1.7493",
  "hubspotter-http-shared-msw-handlers": "static-1.10086",
  "base-ui": "static-1.12",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.985",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4865",
  "content-icons-ui": "static-1.2239",
  "customer-data-ui-utilities": "static-1.9877",
  "conversations-skeleton-state": "static-1.7301",
  "crm-message-bus": "static-1.43104",
  "customer-data-filters-ui-msw-helpers": "static-1.22413",
  "events-data-lib": "static-1.281",
  "FormUrlGenerator": "static-2.4773",
  "framework-builder-read-service-client": "static-1.4045",
  "framework-data-schema-quick-fetch": "static-1.6845",
  "multi-account-reference-resolvers": "static-1.1035",
  "onboarding-tours": "static-1.16702",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13826",
  "academy-common-lib": "static-1.13972",
  "content-assistance-lib": "static-1.7831",
  "dashboard-lib": "static-1.81743",
  "file-manager-components": "static-1.23757",
  "getting-started-shared-tasks": "static-1.18569",
  "hubspot-prosemirror": "static-1.18373",
  "hubspot-prosemirror-plugins": "static-1.18365",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19919",
  "share-with-third-party-component-lib": "static-1.8757",
  "ui-addon-draggable": "static-3.4814",
  "ui-asset-management-lib": "static-1.11105",
  "user-context": "static-1.5160",
  "growth-payments-core": "static-1.25526",
  "reporting-plugins": "static-1.10402",
  "reporting-reports": "static-1.67458",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.775",
  "nest": "static-1.283",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10679",
  "framework-listing-lib": "static-2.28830",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30844",
  "apps-service-types": "static-1.3910",
  "oauth-service-types": "static-1.4303",
  "ui-product-approvals-common": "static-1.198",
  "onboarding-scopes": "static-1.6514",
  "onboarding-tours-client": "static-1.4916",
  "platform-infra-nav-components": "static-1.7712",
  "subscription-experience-data-types": "static-1.15002",
  "crm-record-cards-service-types": "static-1.3630",
  "location-customization-utils-lib": "static-1.9410",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6010",
  "signup-constants": "static-1.18953",
  "signup-ui-url-generator": "static-2.8106",
  "card-properties-lib": "static-1.44350",
  "commerce-subscription-lib": "static-1.37267",
  "crm-actions": "static-1.6390",
  "crm-cards-sdk": "static-1.43740",
  "customer-data-properties-shared-msw-handlers": "static-1.9415",
  "customer-data-tracking": "static-1.6942",
  "hs-resources": "static-1.220",
  "pulse": "static-1.638",
  "calling-global-api": "static-1.64696",
  "calling-internal-common": "static-1.31356",
  "calling-lifecycle-internal": "static-1.66078",
  "calling-lifecycle-messages": "static-1.58372",
  "commerce-products-lib": "static-1.9750",
  "conditional-properties-service-client": "static-1.3838",
  "crm-links": "static-1.6358",
  "crm-pipelines-api-client-types": "static-1.4180",
  "external-options-client-types": "static-1.4199",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4263",
  "meetings-icalendar-utils-lib": "static-1.684",
  "multi-currency-client-types": "static-1.3732",
  "object-builder-ui-client": "static-1.48923",
  "pipeline-validation-client-types": "static-1.4006",
  "smart-property-lib": "static-1.7378",
  "tiered-pricing": "static-1.1332",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11042",
  "fdsr-migration-layer": "static-1.59",
  "react-dnd-compat": "static-1.4666",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1032",
  "growth-data-modal": "static-1.5508",
  "growth-onboarding-confetti": "static-1.3118",
  "growth-onboarding-next-action-utils": "static-1.2068",
  "onboarding-tours-utils": "static-1.768",
  "ui-shepherd-tracker": "static-1.7645",
  "academy-service-client": "static-1.3734",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39256",
  "FileManagerLib": "static-1.39397",
  "video-embed": "static-1.35952",
  "ui-coaching-tips": "static-1.28704",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11460",
  "video-data-lib": "static-1.35118",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8516",
  "payment-link-components": "static-1.23647",
  "ui-addon-emoji-picker": "static-1.9939",
  "EmailSignatureEditor": "static-1.24487",
  "viral-links-lib": "static-1.7120",
  "data-token-picker": "static-1.16497",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.278",
  "timezone-utils": "static-2.5295",
  "seat-types-lib": "static-1.138",
  "getting-started-shared-tasks-store": "static-1.17687",
  "ui-addon-opt": "static-4.8414",
  "campaign-roi-lib": "static-1.9256",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25563",
  "framework-data-table": "static-2.12035",
  "marketing-platform-lib": "static-1.6914",
  "nudge-client-utils": "static-1.2694",
  "nudge-custom-ui-functions": "static-1.1127",
  "switchboard-lib": "static-1.274",
  "app-users-service-client": "static-1.5653",
  "app-users-service-types": "static-1.5061",
  "mini-checkout-client": "static-1.26934",
  "onboarding-utils": "static-1.5409",
  "permissions-shared-i18n-strings-fe": "static-1.2052",
  "ui-coaching-tips-shared-config": "static-1.28689",
  "edison-service-client-types": "static-1.440",
  "crm_data": "static-4.92123",
  "customer-data-sidebar": "static-2.46159",
  "enrichment-properties-lib": "static-1.16496",
  "ui-addon-draggable-compat": "static-2.4311",
  "commerce-billing-lib": "static-1.19242",
  "commerce-shared-components-lib": "static-1.18659",
  "commerce-tools-ui-lib": "static-1.10514",
  "crm-fe-perf": "static-1.22955",
  "event-emitter": "static-1.999",
  "bend-plugin-pulse": "static-1.141",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31363",
  "shared-worker-versioning": "static-1.11089",
  "calling-usage-tracker": "static-1.6593",
  "voice-sms-access-library": "static-1.1209",
  "commerce-permissions": "static-1.826",
  "products-iframe-lib": "static-1.8078",
  "products-ui-components-shared-msw-handlers": "static-1.10470",
  "data-agent-kit": "static-1.276",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10171",
  "policy-lib": "static-1.6830",
  "react-tinymce": "static-1.55387",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10234",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54513",
  "tinymce-plugins": "static-1.57627",
  "tinymce-themes": "static-1.56483",
  "onboarding-data-sync-lib": "static-1.2044",
  "growth-onboarding-next-action-components": "static-1.2096",
  "user-context-client": "static-1.4655",
  "audio-components": "static-1.5993",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36908",
  "urlinator": "static-1.4589",
  "video-components": "static-1.13462",
  "outpost": "static-1.4228",
  "growth-onboarding-feedback-components": "static-1.6631",
  "content-media-composition-data-lib": "static-1.12528",
  "content-media-compositions": "static-2.16535",
  "media-bridge-lib": "static-1.19017",
  "commerce-tours-lib": "static-1.6198",
  "growth-onboarding-reliability": "static-1.5132",
  "sales-checkout-service-client": "static-1.3689",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21765",
  "sales-email-signature-service-client": "static-1.3898",
  "ts-utils-lib": "static-1.224",
  "crm-export-dialog": "static-1.6342",
  "crm-index-associations-lib": "static-1.6494",
  "crm-view-components": "static-1.429",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7380",
  "nudge-custom-function-registry": "static-1.2451",
  "nudge-renderer-utils": "static-1.2770",
  "whisper-core-api": "static-1.6769",
  "InboxConnectUtils": "static-4.14954",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5666",
  "settings-content-modals": "static-1.46232",
  "crm_universal": "static-1.22096",
  "customer-data-email": "static-1.18124",
  "card-payment-highlight-lib": "static-1.37318",
  "card-subscription-highlight-lib": "static-1.39690",
  "commerce-contract-lib": "static-1.12275",
  "invoices-highlight-card-lib": "static-1.54877",
  "orders-highlight-card-lib": "static-1.21609",
  "products-highlight-card-lib": "static-1.18033",
  "quotes-highlight-card-lib": "static-1.72210",
  "crm-source-interpretation-lib": "static-1.5396",
  "utility-belt": "static-1.2586",
  "payments-enrollment-embed-lib": "static-1.23040",
  "stripe-embedded-components": "static-1.7597",
  "customer-data-rte": "static-1.33135",
  "cv-backend-services": "static-1.1555",
  "growth-onboarding-empty-states": "static-1.5831",
  "payments-post-enroll-local-storage-lib": "static-1.5161",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38300",
  "trials-service-types": "static-1.3957",
  "calling-orchestration-schema": "static-1.35986",
  "sales-views-client-types": "static-1.4309",
  "hub-http-contrib": "static-1.3093",
  "interframe": "static-3.4811",
  "tinymce-data": "static-1.40598",
  "ui-addon-sales-email": "static-1.5263",
  "layout-dnd-components": "static-1.12546",
  "layout-dnd-utils": "static-1.11521",
  "ui-brand-identity-lib": "static-1.15483",
  "NamespacedHubStyle": "static-2.9099",
  "meetings-connect-utils-lib": "static-1.7657",
  "social-insights-client-types": "static-1.22239",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4209",
  "checkout-sdk": "static-3.23777",
  "checkout-service-types": "static-1.3846",
  "company-details-components": "static-1.6248",
  "payment-method-components": "static-1.6947",
  "pricing-pages-ui-components": "static-1.14284",
  "quote-checkout-service-types": "static-1.3515",
  "upgrade-catalog-service-types": "static-1.3573",
  "access-control-lib": "static-1.10487",
  "EmailComponents": "static-1.54903",
  "EmailData": "static-1.53580",
  "redux-less": "static-2.9536",
  "sequences-lib": "static-1.8132",
  "ui-gdpr-components": "static-1.10401",
  "products-ui-components": "static-1.40268",
  "accounting-integrations-ui-components": "static-1.7145",
  "invoices-ui-lib": "static-1.54893",
  "commerce-products-api": "static-1.2374",
  "invoices-iframe-lib": "static-1.56951",
  "quotes-modal-lib": "static-1.102888",
  "quotes-ui-lib": "static-1.80931",
  "stripe-connect-js": "static-1.69",
  "draft-content-plugins": "static-1.28407",
  "ContentData": "static-1.68591",
  "layout-data-lib": "static-1.9846",
  "hub-http-rxjs": "static-1.805",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3991",
  "billing-payments-client-types": "static-1.4043",
  "react-performance-metrics-lib": "static-1.609",
  "account-and-billing-fintech-outages": "static-3.18656",
  "pricing-pages-api": "static-1.14149",
  "ContentComponents": "static-2.71472",
  "marketing-contacts-lib": "static-1.10227",
  "marketing-email-service-types": "static-1.1938",
  "messaging-editing-lib": "static-1.46421",
  "messaging-usage-based-billing-components-lib": "static-1.1283",
  "automation-ui-source-apps": "static-1.19027",
  "automation-ui-types": "static-1.19945",
  "messaging-types-lib": "static-1.46158",
  "onboarding-settings-client": "static-1.4557",
  "sequences-client-types-lib": "static-1.7989",
  "commerce-tax-lib": "static-1.583",
  "price-books-api": "static-1.1012",
  "price-books-components": "static-1.1070",
  "property-description-translator": "static-1.3894",
  "ramp-editor": "static-1.266",
  "commerce-analytics-service-client": "static-1.3677",
  "totals-ui-components": "static-1.23749",
  "SalesContentIndexUI": "static-3.9325",
  "advanced-menus-core": "static-1.15209",
  "advanced-menus-lib": "static-1.12144",
  "ui-memberships-settings-lib": "static-1.34186",
  "segments-query-core": "static-1.1469",
  "eligibility-engine-service-types": "static-1.3238",
  "automation-ui-ubb": "static-1.5861",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7391",
  "data-token-views": "static-1.16478",
  "forms-utils-lib": "static-1.12680",
  "payments-embed-points-lib": "static-1.13143",
  "simple-menus-core": "static-1.15208",
  "simple-menus-lib": "static-1.16725",
  "videoconference-integration-components": "static-1.6900",
  "marketing-contacts-client": "static-1.7567",
  "automation-applications-service-types": "static-1.3554",
  "automation-platform-service-types": "static-1.2603",
  "ContentEditorUI": "static-2.77244",
  "short-messages-app-service-client": "static-1.4023",
  "web-interactives-components": "static-1.13848",
  "web-interactives-data": "static-1.13849",
  "messaging-shared-utils-lib": "static-1.732",
  "messaging-user-info-utils-lib": "static-1.902",
  "email-portal-health-service-types": "static-1.1031",
  "line-items-api": "static-1.775",
  "commerce-totals-service-types": "static-1.3859",
  "FireAlarmUi": "static-1.4553",
  "sales-templates-service-types-lib": "static-1.4210",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21881",
  "automation-ui-usage-tracking": "static-1.21344",
  "data-studio-ubb": "static-1.2870",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27153",
  "collaboration-sidebar": "static-1.57960",
  "content-management-data-lib": "static-1.5455",
  "copilot-plugins": "static-1.11245",
  "cta-picker": "static-1.36545",
  "customer-agent-discovery-components-lib": "static-1.3233",
  "editor-components": "static-1.13308",
  "editor-iframe-lib": "static-1.8479",
  "error-messaging-js": "static-1.5245",
  "FormsCommonComponents": "static-1.85993",
  "pictos": "static-7.185",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10699",
  "SharedLegalStrings": "static-1.1800",
  "smart-content-core": "static-1.42587",
  "smart-content-lib": "static-1.43240",
  "social-composer-lib": "static-1.59359",
  "structured-content-lib": "static-1.25332",
  "theme-previewer-lib": "static-1.53380",
  "tinymce-copilot": "static-1.16581",
  "xray-recommendation-lib": "static-1.7977",
  "automation-ui-routing": "static-1.21302",
  "sql-reporting-client-types": "static-1.5678",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42307",
  "campaigns-utils-lib": "static-1.3239",
  "reporting-enablement": "static-1.23106",
  "chatspot-widget-iframe": "static-1.21516",
  "collaboration-sidebar-common": "static-1.2757",
  "forms-ai-lib": "static-1.4397",
  "codemirror-dlb": "static-1.58803",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6484",
  "report-customization-components": "static-1.13312",
  "data-quality-ui-library": "static-1.13182",
  "html-to-image": "static-1.55",
  "reporting-filters": "static-1.461",
  "reporting-insights-lib": "static-1.1894"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12428",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.475",
  "data-fetching-client": "/data-fetching-client/static-1.9716",
  "foundations-components": "/foundations-components/static-1.8031",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1056",
  "foundations-theming": "/foundations-theming/static-1.4476",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8069",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10088",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11525",
  "I18n": "/I18n/static-7.1633",
  "jasmine-runner": "/jasmine-runner/static-1.6515",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12489",
  "quartz": "/quartz/static-1.7095",
  "react-dlb": "/react-dlb/static-1.80",
  "react-rhumb": "/react-rhumb/static-1.16731",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2910",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9713",
  "settings-ui-lib": "/settings-ui-lib/static-1.12571",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7234",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11203",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9593",
  "unified-auth": "/unified-auth/static-1.555",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.837",
  "usage-tracker": "/usage-tracker/static-1.7402",
  "usage-tracker-core": "/usage-tracker-core/static-1.7252",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8144",
  "hub-http": "/hub-http/static-1.6274",
  "integrations-lib": "/integrations-lib/static-1.16330",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19960",
  "property-management-iframe": "/property-management-iframe/static-1.13331",
  "quartz-config": "/quartz-config/static-1.873",
  "quartz-core": "/quartz-core/static-1.6314",
  "quartz-routing": "/quartz-routing/static-1.525",
  "quick-fetch": "/quick-fetch/static-1.3958",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4704",
  "ts-schema": "/ts-schema/static-1.4120",
  "ui-universal-auth": "/ui-universal-auth/static-1.9041",
  "UIComponents": "/UIComponents/static-3.8471",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3440",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3372",
  "quartz-webpack": "/quartz-webpack/static-1.3319",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.173",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4300",
  "floating-ui": "/floating-ui/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4921",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2192",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9475",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.31",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5384",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2075",
  "ui-fonts": "/ui-fonts/static-1.787",
  "ui-images": "/ui-images/static-2.1165",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2959",
  "foundations-theming-base": "/foundations-theming-base/static-1.3461",
  "stylex": "/stylex/static-1.34",
  "HeadJS": "/HeadJS/static-2.765",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3180",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4377",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9097",
  "ai-rendering-library": "/ai-rendering-library/static-1.10349",
  "chirp-fetch": "/chirp-fetch/static-1.1939",
  "connections-embed-lib": "/connections-embed-lib/static-1.1089",
  "copilot-toolkit": "/copilot-toolkit/static-1.11272",
  "feedback-loader": "/feedback-loader/static-1.29391",
  "laboratory-lib": "/laboratory-lib/static-3.7208",
  "marketplace-embed": "/marketplace-embed/static-1.22236",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9855",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19915",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14130",
  "sanitize-text": "/sanitize-text/static-1.8194",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8756",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5816",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5088",
  "wootric-nps": "/wootric-nps/static-1.7022",
  "quartz-head": "/quartz-head/static-1.760",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4703",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4205",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2525",
  "reporting-data": "/reporting-data/static-1.67780",
  "cssUtils": "/cssUtils/static-1.804",
  "flux-actions": "/flux-actions/static-1.341",
  "HubStyle": "/HubStyle/static-2.11832",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10261",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10417",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7392",
  "icons": "/icons/static-2.650",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18492",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4565",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5514",
  "quartz-i18n": "/quartz-i18n/static-1.770",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.39",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.387",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.522",
  "slack-ui-library": "/slack-ui-library/static-1.10444",
  "fsm": "/fsm/static-1.3782",
  "customer-data-objects": "/customer-data-objects/static-1.7729",
  "property-translator": "/property-translator/static-1.5450",
  "hs-locale-management": "/hs-locale-management/static-1.121",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7978",
  "hs-promise-utils": "/hs-promise-utils/static-1.5643",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4929",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13745",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5657",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7834",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4528",
  "superstore": "/superstore/static-1.4812",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10264",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7966",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "hubspotter-http": "/hubspotter-http/static-1.4691",
  "immutable-less": "/immutable-less/static-1.4704",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17367",
  "nav-meta": "/nav-meta/static-1.29803",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10300",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18069",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3886",
  "property-management-common": "/property-management-common/static-1.5619",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9113",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.770",
  "quartz-test": "/quartz-test/static-1.770",
  "quartz-tracking": "/quartz-tracking/static-1.474",
  "trellis-components": "/trellis-components/static-1.2094",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.114",
  "bender-build-tools": "/bender-build-tools/static-1.3254",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21525",
  "ContentUtils": "/ContentUtils/static-1.68516",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13084",
  "sassPrefix": "/sassPrefix/static-1.157",
  "breeze-engine-core": "/breeze-engine-core/static-1.115",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.138",
  "avatar-components": "/avatar-components/static-1.2550",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39978",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13221",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14512",
  "ExportDialog": "/ExportDialog/static-6.10437",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41443",
  "reporting-snowflake": "/reporting-snowflake/static-1.56398",
  "reporting-ui-components": "/reporting-ui-components/static-2.65051",
  "reporting-visualizations": "/reporting-visualizations/static-1.59856",
  "ui-addon-teams": "/ui-addon-teams/static-1.21625",
  "magpie-lib": "/magpie-lib/static-1.5585",
  "navigation-components": "/navigation-components/static-1.18166",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.837",
  "magpie-types": "/magpie-types/static-1.5045",
  "simple-logging-lib": "/simple-logging-lib/static-1.3103",
  "ai-studio-lib": "/ai-studio-lib/static-1.11763",
  "app-governance-lib": "/app-governance-lib/static-1.1718",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10564",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8054",
  "ui-product-approvals": "/ui-product-approvals/static-1.28303",
  "ui-tool-access": "/ui-tool-access/static-1.10201",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9178",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5819",
  "usage-tracker-public": "/usage-tracker-public/static-1.7213",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3626",
  "persist-promise": "/persist-promise/static-1.3751",
  "reference-resolvers": "/reference-resolvers/static-1.8223",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3978",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.388",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3070",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2922",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "atom": "/atom/static-1.5126",
  "purchase-motions-components": "/purchase-motions-components/static-1.6007",
  "salesImages": "/salesImages/static-1.526",
  "batch-promise": "/batch-promise/static-1.1594",
  "crm-component-utils": "/crm-component-utils/static-1.39214",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5940",
  "customer-data-properties": "/customer-data-properties/static-1.51751",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6940",
  "property-value-citations": "/property-value-citations/static-1.2365",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8150",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9109",
  "navigation-messaging": "/navigation-messaging/static-1.7493",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10086",
  "base-ui": "/base-ui/static-1.12",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.985",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4865",
  "content-icons-ui": "/content-icons-ui/static-1.2239",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9877",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7301",
  "crm-message-bus": "/crm-message-bus/static-1.43104",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22413",
  "events-data-lib": "/events-data-lib/static-1.281",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4773",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4045",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6845",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1035",
  "onboarding-tours": "/onboarding-tours/static-1.16702",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13826",
  "academy-common-lib": "/academy-common-lib/static-1.13972",
  "content-assistance-lib": "/content-assistance-lib/static-1.7831",
  "dashboard-lib": "/dashboard-lib/static-1.81743",
  "file-manager-components": "/file-manager-components/static-1.23757",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18569",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18373",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18365",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19919",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8757",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4814",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11105",
  "user-context": "/user-context/static-1.5160",
  "growth-payments-core": "/growth-payments-core/static-1.25526",
  "reporting-plugins": "/reporting-plugins/static-1.10402",
  "reporting-reports": "/reporting-reports/static-1.67458",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.775",
  "nest": "/nest/static-1.283",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10679",
  "framework-listing-lib": "/framework-listing-lib/static-2.28830",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30844",
  "apps-service-types": "/apps-service-types/static-1.3910",
  "oauth-service-types": "/oauth-service-types/static-1.4303",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.198",
  "onboarding-scopes": "/onboarding-scopes/static-1.6514",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4916",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7712",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15002",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3630",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9410",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6010",
  "signup-constants": "/signup-constants/static-1.18953",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8106",
  "card-properties-lib": "/card-properties-lib/static-1.44350",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37267",
  "crm-actions": "/crm-actions/static-1.6390",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43740",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9415",
  "customer-data-tracking": "/customer-data-tracking/static-1.6942",
  "hs-resources": "/hs-resources/static-1.220",
  "pulse": "/pulse/static-1.638",
  "calling-global-api": "/calling-global-api/static-1.64696",
  "calling-internal-common": "/calling-internal-common/static-1.31356",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66078",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58372",
  "commerce-products-lib": "/commerce-products-lib/static-1.9750",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3838",
  "crm-links": "/crm-links/static-1.6358",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4180",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4263",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.684",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3732",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48923",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4006",
  "smart-property-lib": "/smart-property-lib/static-1.7378",
  "tiered-pricing": "/tiered-pricing/static-1.1332",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11042",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.59",
  "react-dnd-compat": "/react-dnd-compat/static-1.4666",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1032",
  "growth-data-modal": "/growth-data-modal/static-1.5508",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3118",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2068",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.768",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7645",
  "academy-service-client": "/academy-service-client/static-1.3734",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39256",
  "FileManagerLib": "/FileManagerLib/static-1.39397",
  "video-embed": "/video-embed/static-1.35952",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28704",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11460",
  "video-data-lib": "/video-data-lib/static-1.35118",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8516",
  "payment-link-components": "/payment-link-components/static-1.23647",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9939",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24487",
  "viral-links-lib": "/viral-links-lib/static-1.7120",
  "data-token-picker": "/data-token-picker/static-1.16497",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.278",
  "timezone-utils": "/timezone-utils/static-2.5295",
  "seat-types-lib": "/seat-types-lib/static-1.138",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17687",
  "ui-addon-opt": "/ui-addon-opt/static-4.8414",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9256",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25563",
  "framework-data-table": "/framework-data-table/static-2.12035",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6914",
  "nudge-client-utils": "/nudge-client-utils/static-1.2694",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1127",
  "switchboard-lib": "/switchboard-lib/static-1.274",
  "app-users-service-client": "/app-users-service-client/static-1.5653",
  "app-users-service-types": "/app-users-service-types/static-1.5061",
  "mini-checkout-client": "/mini-checkout-client/static-1.26934",
  "onboarding-utils": "/onboarding-utils/static-1.5409",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2052",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28689",
  "edison-service-client-types": "/edison-service-client-types/static-1.440",
  "crm_data": "/crm_data/static-4.92123",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46159",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16496",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4311",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19242",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18659",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10514",
  "crm-fe-perf": "/crm-fe-perf/static-1.22955",
  "event-emitter": "/event-emitter/static-1.999",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.141",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31363",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11089",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6593",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1209",
  "commerce-permissions": "/commerce-permissions/static-1.826",
  "products-iframe-lib": "/products-iframe-lib/static-1.8078",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10470",
  "data-agent-kit": "/data-agent-kit/static-1.276",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10171",
  "policy-lib": "/policy-lib/static-1.6830",
  "react-tinymce": "/react-tinymce/static-1.55387",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10234",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54513",
  "tinymce-plugins": "/tinymce-plugins/static-1.57627",
  "tinymce-themes": "/tinymce-themes/static-1.56483",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2044",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2096",
  "user-context-client": "/user-context-client/static-1.4655",
  "audio-components": "/audio-components/static-1.5993",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36908",
  "urlinator": "/urlinator/static-1.4589",
  "video-components": "/video-components/static-1.13462",
  "outpost": "/outpost/static-1.4228",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6631",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12528",
  "content-media-compositions": "/content-media-compositions/static-2.16535",
  "media-bridge-lib": "/media-bridge-lib/static-1.19017",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6198",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5132",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3689",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21765",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3898",
  "ts-utils-lib": "/ts-utils-lib/static-1.224",
  "crm-export-dialog": "/crm-export-dialog/static-1.6342",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6494",
  "crm-view-components": "/crm-view-components/static-1.429",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7380",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2451",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2770",
  "whisper-core-api": "/whisper-core-api/static-1.6769",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14954",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5666",
  "settings-content-modals": "/settings-content-modals/static-1.46232",
  "crm_universal": "/crm_universal/static-1.22096",
  "customer-data-email": "/customer-data-email/static-1.18124",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37318",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39690",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12275",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54877",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21609",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18033",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72210",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5396",
  "utility-belt": "/utility-belt/static-1.2586",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23040",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7597",
  "customer-data-rte": "/customer-data-rte/static-1.33135",
  "cv-backend-services": "/cv-backend-services/static-1.1555",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5831",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5161",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38300",
  "trials-service-types": "/trials-service-types/static-1.3957",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35986",
  "sales-views-client-types": "/sales-views-client-types/static-1.4309",
  "hub-http-contrib": "/hub-http-contrib/static-1.3093",
  "interframe": "/interframe/static-3.4811",
  "tinymce-data": "/tinymce-data/static-1.40598",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5263",
  "layout-dnd-components": "/layout-dnd-components/static-1.12546",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11521",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15483",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9099",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7657",
  "social-insights-client-types": "/social-insights-client-types/static-1.22239",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4209",
  "checkout-sdk": "/checkout-sdk/static-3.23777",
  "checkout-service-types": "/checkout-service-types/static-1.3846",
  "company-details-components": "/company-details-components/static-1.6248",
  "payment-method-components": "/payment-method-components/static-1.6947",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14284",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3515",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3573",
  "access-control-lib": "/access-control-lib/static-1.10487",
  "EmailComponents": "/EmailComponents/static-1.54903",
  "EmailData": "/EmailData/static-1.53580",
  "redux-less": "/redux-less/static-2.9536",
  "sequences-lib": "/sequences-lib/static-1.8132",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10401",
  "products-ui-components": "/products-ui-components/static-1.40268",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7145",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54893",
  "commerce-products-api": "/commerce-products-api/static-1.2374",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56951",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102888",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80931",
  "stripe-connect-js": "/stripe-connect-js/static-1.69",
  "draft-content-plugins": "/draft-content-plugins/static-1.28407",
  "ContentData": "/ContentData/static-1.68591",
  "layout-data-lib": "/layout-data-lib/static-1.9846",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.805",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3991",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4043",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.609",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18656",
  "pricing-pages-api": "/pricing-pages-api/static-1.14149",
  "ContentComponents": "/ContentComponents/static-2.71472",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10227",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1938",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46421",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1283",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19027",
  "automation-ui-types": "/automation-ui-types/static-1.19945",
  "messaging-types-lib": "/messaging-types-lib/static-1.46158",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4557",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7989",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.583",
  "price-books-api": "/price-books-api/static-1.1012",
  "price-books-components": "/price-books-components/static-1.1070",
  "property-description-translator": "/property-description-translator/static-1.3894",
  "ramp-editor": "/ramp-editor/static-1.266",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3677",
  "totals-ui-components": "/totals-ui-components/static-1.23749",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9325",
  "advanced-menus-core": "/advanced-menus-core/static-1.15209",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12144",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34186",
  "segments-query-core": "/segments-query-core/static-1.1469",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3238",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5861",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7391",
  "data-token-views": "/data-token-views/static-1.16478",
  "forms-utils-lib": "/forms-utils-lib/static-1.12680",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13143",
  "simple-menus-core": "/simple-menus-core/static-1.15208",
  "simple-menus-lib": "/simple-menus-lib/static-1.16725",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6900",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7567",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3554",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2603",
  "ContentEditorUI": "/ContentEditorUI/static-2.77244",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4023",
  "web-interactives-components": "/web-interactives-components/static-1.13848",
  "web-interactives-data": "/web-interactives-data/static-1.13849",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.732",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.902",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1031",
  "line-items-api": "/line-items-api/static-1.775",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3859",
  "FireAlarmUi": "/FireAlarmUi/static-1.4553",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4210",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21881",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21344",
  "data-studio-ubb": "/data-studio-ubb/static-1.2870",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27153",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57960",
  "content-management-data-lib": "/content-management-data-lib/static-1.5455",
  "copilot-plugins": "/copilot-plugins/static-1.11245",
  "cta-picker": "/cta-picker/static-1.36545",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3233",
  "editor-components": "/editor-components/static-1.13308",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8479",
  "error-messaging-js": "/error-messaging-js/static-1.5245",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85993",
  "pictos": "/pictos/static-7.185",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10699",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1800",
  "smart-content-core": "/smart-content-core/static-1.42587",
  "smart-content-lib": "/smart-content-lib/static-1.43240",
  "social-composer-lib": "/social-composer-lib/static-1.59359",
  "structured-content-lib": "/structured-content-lib/static-1.25332",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53380",
  "tinymce-copilot": "/tinymce-copilot/static-1.16581",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7977",
  "automation-ui-routing": "/automation-ui-routing/static-1.21302",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5678",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42307",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3239",
  "reporting-enablement": "/reporting-enablement/static-1.23106",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21516",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2757",
  "forms-ai-lib": "/forms-ai-lib/static-1.4397",
  "codemirror-dlb": "/codemirror-dlb/static-1.58803",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6484",
  "report-customization-components": "/report-customization-components/static-1.13312",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13182",
  "html-to-image": "/html-to-image/static-1.55",
  "reporting-filters": "/reporting-filters/static-1.461",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1894"
}
};
